import { formatPrice } from "@grandvisionhq/utils";
const getDiscount = (locale, currencyCode, discountType, discountedPrice) => {
  if (!discountedPrice || !discountType || !currencyCode) return void 0;
  if (discountType.toLowerCase() === "absolute") {
    return `-${formatPrice({
      locale,
      value: discountedPrice,
      currency: currencyCode,
      isCentAmount: false
    })}`;
  } else if (discountType.toLowerCase() === "relative") {
    return `-${discountedPrice}%`;
  } else {
    return void 0;
  }
};
export {
  getDiscount
};
//# sourceMappingURL=get-discount.js.map
